import apiClient from './client';
import type {
  CreateSetlistPayload,
  ReorderItemsPayload,
  Setlist,
  SetlistDetail,
  SetlistItem,
  UpdateSetlistPayload,
} from '../types/setlist';

export const setlistsApi = {
  list: (teamId: string, search?: string) =>
    apiClient.get<Setlist[]>(`/teams/${teamId}/setlists/`, {
      params: search ? { search } : undefined,
    }),

  create: (teamId: string, payload: CreateSetlistPayload) =>
    apiClient.post<Setlist>(`/teams/${teamId}/setlists/`, payload),

  get: (teamId: string, setlistId: string) =>
    apiClient.get<SetlistDetail>(`/teams/${teamId}/setlists/${setlistId}/`),

  update: (teamId: string, setlistId: string, payload: UpdateSetlistPayload) =>
    apiClient.patch<SetlistDetail>(`/teams/${teamId}/setlists/${setlistId}/`, payload),

  delete: (teamId: string, setlistId: string) =>
    apiClient.delete(`/teams/${teamId}/setlists/${setlistId}/`),

  addItem: (teamId: string, setlistId: string, songId: string, keyOverride?: string) =>
    apiClient.post<SetlistItem>(`/teams/${teamId}/setlists/${setlistId}/items/`, {
      song_id: songId,
      key_override: keyOverride ?? '',
    }),

  updateItem: (
    teamId: string,
    setlistId: string,
    itemId: string,
    payload: Partial<Pick<SetlistItem, 'key_override' | 'youtube_url' | 'spotify_url'>>,
  ) =>
    apiClient.patch<SetlistItem>(`/teams/${teamId}/setlists/${setlistId}/items/${itemId}/`, {
      ...payload,
    }),

  removeItem: (teamId: string, setlistId: string, itemId: string) =>
    apiClient.delete(`/teams/${teamId}/setlists/${setlistId}/items/${itemId}/`),

  reorderItems: (teamId: string, setlistId: string, payload: ReorderItemsPayload) =>
    apiClient.post<SetlistDetail>(
      `/teams/${teamId}/setlists/${setlistId}/reorder/`,
      payload,
    ),
};
